        <!-- DataChart 协议卡图形报表 -->
<template>
  <div>
    <!-- 表头 -->
    <div class="dataChart">
      <div class="dataChart_return" @click="returnClick()">
        <i class="el-icon-arrow-left fl"></i>
        <span class="fl">返回</span>
      </div>
      <h1>协议卡图形报表</h1>
      <div class="dataChart_time clearfix">
        <i class="el-icon-date fl"></i>
        <span class="fl">{{ dataTime }}</span>
        <span class="fl">{{ textTime }}</span>
      </div>
    </div>

    <!-- 查询条件 -->
    <div class="graphics_search clearfix">
      <div class="graphics_box fl" v-show="options.length > 0">
        <span class="fl">归属机构：</span>
        <el-cascader
          class="fl"
          :clearable="true"
          v-model="value"
          :checkStrictly="true"
          :options="options"
          placeholder="系统管理机构"
          filterable
          :props="{ expandTrigger: 'hover', checkStrictly: true }"
          @change="handleChange"
        ></el-cascader>
      </div>
      <div class="graphics_box fl">
        <span class="fl">采集点：</span>
        <el-select class="fl" v-model="deviceId" placeholder="请选择">
          <el-option
            v-for="item in patchLists"
            :key="item.value"
            :label="item.deviceName"
            :value="item.deviceId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="graphics_box fl">
        <span class="fl">数据项：</span>
        <el-select class="fl" v-model="dataId" placeholder="请选择">
          <el-option
            v-for="(item, index) in dataList"
            :key="index"
            :label="item.value"
            :value="item.dataId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="graphics_box fl">
        <span class="fl">记录日期：</span>
        <el-date-picker v-model="beginDate" type="date" placeholder="选择日期">
        </el-date-picker>
      </div>
      <div class="graphics_box fl">
        <el-button
          class="fl"
          type="primary"
          @click="queryClick()"
          icon="el-icon-search"
          >查询</el-button
        >
      </div>
      <!-- <div class="graphics_box fl">
        <el-button
          class="fl"
          type="success"
          icon="el-icon-upload2"
          @click="exportClick()"
          >导出</el-button
        >
      </div> -->
    </div>

    <el-divider></el-divider>
    <div id="charts" class="chart_box"></div>
    <el-divider></el-divider>
  </div>
</template>

<script>
// 引入日期时间
import { dateTime } from "../../assets/js/data";
import { JSONToExcelConvertor } from "../../assets/js/excel";
export default {
  data() {
    return {
      // 监听窗口变化
      screenWidth: document.body.clientWidth,
      // 定时器
      timer: "",
      // 日期时间
      dataTime: "",
      // 星期
      textTime: "",

      // 归属机构ID
      deptId: "",
      // 当前机构LIST
      value: [],
      // 机构树
      options: [],
      //  采集点
      deviceId: "",
      //  采集点list
      patchLists: [],

      // 记录日期
      beginDate: "",

      // 数据项ID
      dataId: "",
      // 数据项LIST
      dataList: [],

      // 图表数据
      HJ212StatList: [],

      legendData: "",
      series: "",

      nameToDescList: [],

      timeDate: [
        "0时",
        "1时",
        "2时",
        "3时",
        "4时",
        "5时",
        "6时",
        "7时",
        "8时",
        "9时",
        "10时",
        "11时",
        "12时",
        "13时",
        "14时",
        "15时",
        "16时",
        "17时",
        "18时",
        "19时",
        "20时",
        "21时",
        "22时",
        "23时",
      ],
    };
  },
  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timers) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timers = true;
        let that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          // console.log(that.screenWidth);

          let title = {};
          title.text = "系统管理机构";
          title.subtext = "暂无数据";
          // 当天统计图表 初始化
          that.chartsBox(title, [], []);

          that.timers = false;
        }, 1000);
      }
    },
  },
  created() {
    //   日期时间赋值
    this.dataTime = dateTime();
    //   清除定时器
    window.clearInterval(this.timer);
    let _this = this;
    // 定时更新时间
    this.timer = setInterval(() => {
      _this.dataTime = dateTime();
    }, 1000);

    let date = new Date();
    let num = date.getDay();
    if (num == 0) {
      this.textTime = "星期天";
    }
    if (num == 1) {
      this.textTime = "星期一";
    }
    if (num == 2) {
      this.textTime = "星期二";
    }
    if (num == 3) {
      this.textTime = "星期三";
    }
    if (num == 4) {
      this.textTime = "星期四";
    }
    if (num == 5) {
      this.textTime = "星期五";
    }
    if (num == 6) {
      this.textTime = "星期六";
    }

    // 当前日期
    this.beginDate = date;

    // 获取结构树
    this.options = JSON.parse(localStorage.getItem("structure"));
    this.dataList = JSON.parse(localStorage.getItem("dataItems"));

    this.nameToDescList = JSON.parse(localStorage.getItem("dataItems"));

    if (localStorage.getItem("loginToken")) {
      // 初始化采集点
      this.HJ212Records("");
    }
  },

  mounted() {
    let title = {};
    title.text = "系统管理机构";
    title.subtext = "暂无数据";
    // 当天统计图表 初始化
    this.chartsBox(title, [], this.timeDate, []);

    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  },
  methods: {
    // 导出
    exportClick() {
      if (this.series.length == 0) {
        this.$message({
          message: "暂无数据！",
          type: "warning",
        });
        return;
      }
      let arr = [];
      for (let i = 0; i < this.legendData.length; i++) {
        arr.push({
          keys: this.legendData[i].split("/")[0],
          value: this.legendData[i],
        });
      }
      arr.push({
        keys: "time",
        value: "记录时间",
      });

      let list = [];
      for (let i = 0; i < 24; i++) {
        (function (i) {
          let at = {};
          for (let j = 0; j < arr.length; j++) {
            at[arr[j].keys] = "";
          }
          list.push(at);
        })(i);
      }

      let _this = this;
      for (let i = 0; i < this.series.length; i++) {
        (function (i) {
          for (let j = 0; j < arr.length; j++) {
            if (_this.series[i].name == arr[j].value) {
              (function (i, j) {
                for (let k = 0; k < _this.series[i].data.length; k++) {
                  if (_this.series[i].data[k] == "") {
                    list[k][arr[j].keys] = "99999999";
                  } else {
                    list[k][arr[j].keys] = _this.series[i].data[k];
                  }
                }
              })(i, j);
            }
          }
        })(i);
      }

      var timeDate = new Date();
      var n = timeDate.getFullYear();
      var y = timeDate.getMonth() + 1;
      var r = timeDate.getDate();

      y = y > 9 ? y : "0" + y;
      r = r > 9 ? r : "0" + r;

      for (let i = 0; i < list.length; i++) {
        (function (i) {
          list[i].time = n + "-" + y + "-" + r + " " + (i > 9 ? i : "0" + i);
        })(i);
      }
      let s =
        timeDate.getHours() > 9
          ? timeDate.getHours()
          : "0" + timeDate.getHours();
      let f =
        timeDate.getMinutes() > 9
          ? timeDate.getMinutes()
          : "0" + timeDate.getMinutes();
      let m =
        timeDate.getSeconds() > 9
          ? timeDate.getSeconds()
          : "0" + timeDate.getSeconds();

      let textName = "HJ212图形报表_" + n + y + r + s + f + m;

      var values = "";
      for (let i = 0; i < this.patchLists.length; i++) {
        if (this.patchLists[i].deviceId == this.deviceId) {
          values = this.patchLists[i].deviceName;
          break;
        }
      }

      JSONToExcelConvertor(values, arr, list, textName);
    },
    // 当天统计图表
    chartsBox(title, titleDate, timeDate, seriesDate) {
      //  销毁echarts实例
      this.echarts.dispose(document.getElementById("charts"));
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.echarts.init(document.getElementById("charts"));

      // 指定图表的配置项和数据
      var option = {
        title,
        tooltip: {
          trigger: "axis",
        },
        grid: {
          y: 120,
        },
        legend: {
          data: titleDate,
          y: "38px",
        },
        toolbox: {
          show: true,
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar", "stack"] },
          },
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: timeDate,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: seriesDate,
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    // 获取机构下的采集点
    HJ212Records(deptId) {
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DataRecords",
          deptId,
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == "0") {
            // 获取机构下的采集点
            this.patchLists = res.data.devices;
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 小时 报表查询（HJ212汇总统计）
    HJ212Stat(deviceId, dataId, beginDate) {
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "DataChart", //交易码
          option: "SHOW", //交易选项，不填则返回设备列表
          deptId: this.deptId, //归属机构ID
          deviceId: deviceId, //设备ID，option填SHOW时要把deviceId填上。
          dataId: dataId, //数据项ID，如0005，option填SHOW时要把dataId填上。
          beginDate: beginDate, //记录日期
          loginToken,
        },
      })
        .then((res) => {
          console.log(res);
          // 登录超时
          if (res.data._STATUS == "0") {
            if (res.data.list.length > 0) {
              let title = {};
              title.subtext = "";
              for (let i = 0; i < this.patchLists.length; i++) {
                if (this.patchLists[i].deviceId == this.deviceId) {
                  title.text = this.patchLists[i].deviceName;
                  break;
                }
              }

              var _this = this;
              let timeDate = [];
              let titleDate = [];
              let seriesDate = [];

              for (let i = 0; i < this.nameToDescList.length; i++) {
                titleDate.push(_this.nameToDescList[i].value);
                let arr = {
                  name: this.nameToDescList[i].value,
                  type: "line",
                  stack: "总量",
                  val: this.nameToDescList[i].keys,
                  data: [],
                };
                seriesDate.push(arr);
              }
              for (let j = 0; j < res.data.list.length; j++) {
                timeDate.push(res.data.list[j].drTime);
              }

              for (let i = 0; i < res.data.list.length; i++) {
                for (var j in res.data.list[0]) {
                  ((i, j) => {
                    for (let k = 0; k < seriesDate.length; k++) {
                      if (seriesDate[k].val == j) {
                        seriesDate[k].data.push(
                          res.data.list[i][seriesDate[k].val]
                        );
                      }
                    }
                  })(i, j);
                }
              }

              this.chartsBox(title, titleDate, timeDate, seriesDate);
            } else {
              this.$message({
                message: "暂无数据！",
                type: "warning",
              });
              let title = {};
              title.subtext = "暂无数据";
              for (let i = 0; i < this.patchLists.length; i++) {
                if (this.patchLists[i].deviceId == this.deviceId) {
                  title.text = this.patchLists[i].deviceName;
                  break;
                }
              }
              this.chartsBox(title, [], this.timeDate, []);
            }
          } else {
            // 登录超时，调用全局方法
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查询数据
    queryClick() {
      if (this.deviceId !== "" && this.dataId !== "" && this.beginDate !== null) {
        let n1 = this.beginDate.getFullYear();
        let y1 =
          this.beginDate.getMonth() + 1 > 9
            ? this.beginDate.getMonth() + 1
            : "0" + (this.beginDate.getMonth() + 1);
        let r1 =
          this.beginDate.getDate() > 9
            ? this.beginDate.getDate()
            : "0" + this.beginDate.getDate();

        let beginDate = n1 + "-" + y1 + "-" + r1;
        this.HJ212Stat(this.deviceId, this.dataId, beginDate);
      } else {
        this.$message({
          message: "查询参数不能为空！",
          type: "warning",
        });
      }
    },
    // 现在所属机构
    handleChange(value) {
      this.deviceId = "";
      let val = JSON.parse(JSON.stringify(value));
      if (val.length >= 1) {
        this.deptId = val[val.length - 1];
      } else {
        this.deptId = "";
      }
      // 获取采集点
      this.HJ212Records(this.deptId);
    },
    // 返回上一级
    returnClick() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
// 表头
.dataChart {
  width: 100%;
  height: 50px;
  background-color: #304156;
  position: relative;
  h1 {
    min-width: 300px;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    font-size: 26px;
    letter-spacing: 6px;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
  .dataChart_return {
    position: absolute;
    top: 0;
    left: 0;
    height: 50px;
    overflow: hidden;
    line-height: 50px;
    color: #fff;
    &:hover {
      cursor: pointer;
      text-shadow: #000 0 0 2px;
    }
    i {
      font-weight: bold;
      margin-left: 20px;
      font-size: 20px;
      line-height: 52px;
    }
    span {
      line-height: 50px;
      font-size: 20px;
    }
  }
  .dataChart_time {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    padding: 0 20px;
    color: #fff;
    i {
      font-size: 32px;
      line-height: 50px;
    }
    span {
      margin: 0 20px;
      font-size: 28px;
      line-height: 50px;
    }
  }
}

// 查询条件
.graphics_search {
  width: 100%;
  min-height: 60px;
  margin-top: 10px;
  .graphics_box {
    height: 40px;
    line-height: 40px;
    margin: 10px 15px 10px 15px;
  }
}

.chart_box {
  width: calc(100% - 40px);
  height: 500px;
  margin: 10px 20px;
  margin-top: 20px;
  background-color: #fff;
}
</style>
